import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BreadcrumbItem } from "../DashboardNew/BreadcrumbHeader";
import { useOrganizationService, useResourcesService } from "../../services";
import { useJwt } from "../../helpers/common";
import useIntegrationStatus from "../../hooks/useIntegrationStatus";
import { SearchMode, TabType, ViewType } from "./types";
import { ComponentPage } from "../../constants/constants";
import { ResourceHeader } from "./components";
import ResourcesUtilizations from "./ResourcesUtilizations";
import { useSideNavContext } from "../../context/SideNavContext";
import { useNavigate } from "react-router-dom";
import {
  setResourceActiveTab,
  setResourceCurrentView,
  setResourceSearchMode,
  setResourceSearchTerm,
  setResourcesSprints,
} from "../../redux/slices/resources";

const Resource: React.FC = () => {
  const dispatch = useDispatch();
  const JWTdata: any = useJwt();
  const org_id = JWTdata.org_id;
  const user_id = JWTdata.user_id;

  const { isOpenOnSmallScreens } = useSideNavContext();
  const { fetchSprints, fetchOrganizationSkill } = useOrganizationService();
  const { fetchManagerResources } = useResourcesService();
  const { fetchTeams } = useOrganizationService();
  const { isIntegrationActive, activeIntegrations } = useIntegrationStatus();
  const azureActive = isIntegrationActive('azure');

  // Remove useUrlFilters because this page only has Capacity view now.

  const {
    data: resources,
    resourcePageState,
  } = useSelector((state: any) => state.resources);

  const { currentView } = resourcePageState;

  const fetchAllSprints = async () => {
    if (!azureActive) {
      return;
    }

    const sprints = await fetchSprints('azure');
    dispatch(setResourcesSprints(sprints?.filter(Boolean) || []));
  }

  useEffect(() => {
    if (org_id) {
      fetchManagerResources(org_id);
      fetchOrganizationSkill(org_id);
      fetchTeams(org_id);
    }
  }, [org_id]);

  useEffect(() => {
    fetchAllSprints()
  }, [activeIntegrations])

  useEffect(() => {
    dispatch(setResourceSearchTerm(''));
    dispatch(setResourceSearchMode(SearchMode.NAME));
  }, []);

  // Force CAPACITY view on the Resource page at all times
  useEffect(() => {
    if (currentView !== ViewType.CAPACITY) {
      dispatch(setResourceCurrentView(ViewType.CAPACITY));
    }
  }, [currentView, dispatch]);

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    return [
      { label: 'Capacity Planning', href: '#', active: true }
    ];
  };

  const navigate = useNavigate();

  const handleManageInvitesClick = () => {
    navigate('/people');
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <>
      <div
        className="flex flex-col h-screen"
        style={{
          width: !isOpenOnSmallScreens
            ? "calc(100vw - 255px)"
            : "calc(100vw - 65px)",
        }}
      >
        <div className="relative z-50">
          <ResourceHeader
            breadcrumbs={breadcrumbs}
            onManageInvitesClick={handleManageInvitesClick}
            currentView={ViewType.CAPACITY}
          />
        </div>

        <div className="flex-1 overflow-hidden bg-tertiary-light dark:bg-tertiary-dark">
          <div className="p-0 h-full w-full">
            <ResourcesUtilizations
              resources={resources}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Resource;